import React from 'react'
import { useHistory } from 'react-router-dom'
import MUIDataTable from 'mui-datatables'

import { Container, Typography } from 'src/modules/ui'
import { useFetchInvoicesQuery } from '../api'
import { formatDate, formatPrice } from 'src/utils'

const InvoiceList = ({ title = 'Sent Invoices' }) => {
  const invoicesQuery = useFetchInvoicesQuery()
  const history = useHistory()

  if (invoicesQuery.isLoading) {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    )
  }

  const invoices = invoicesQuery.data

  const data = invoices.map(invoice => {
    const {
      buyer,
      deliveryCharge,
      dueDate,
      total,
      goodsTotal,
      invoiceDate,
      otherCharge,
    } = invoice
    return {
      ...invoice,
      buyer: buyer.name,
      goodsTotal: formatPrice(goodsTotal),
      invoiceDate: formatDate(invoiceDate),
      dueDate: formatDate(dueDate),
      deliveryCharge: formatPrice(deliveryCharge),
      otherCharge: formatPrice(otherCharge),
      total: formatPrice(total),
    }
  })

  const columns = [
    {
      name: 'invoiceNumber',
      label: 'Invoice Number',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'invoiceDate',
      label: 'Invoice Date',
      options: {
        filter: true,
        sort: true,
        sortDirection: 'asc',
      },
    },
    {
      name: 'dueDate',
      label: 'Due Date',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'buyer',
      label: 'Buyer',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'goodsTotal',
      label: 'Goods Total',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'total',
      label: 'Total',
      options: {
        filter: false,
        sort: true,
      },
    },
  ]

  const options = {
    download: false,
    elevation: 0,
    onRowClick: (row, { dataIndex }) => {
      history.push(`/invoices/${invoices[dataIndex].id}`)
    },
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: false,
    viewColumns: false,
  }

  return (
    <Container muiTable>
      <MUIDataTable
        columns={columns}
        data={data}
        options={options}
        title={title}
      />
    </Container>
  )
}

export default InvoiceList
